import { redirect, RouteObject } from "react-router-dom";
import { Layout } from "../Layout/Layout";
import React from "react";

const CoinFlipPage = React.lazy(
  async () => await import("../Pages/CoinFlip/CoinFlipPage")
);
const CoinFlipEntityPage = React.lazy(
  async () => await import("../Pages/CoinFlip/Database/EntityPage")
);

const CoinFlipProfilePage = React.lazy(
  async () => await import("../Pages/CoinFlip/Profile/ProfilePage")
);

export const RouterCoinFlip: RouteObject[] = [
  {
    path: "/game/coinFlip/",
    loader: async () => {
      // Здесь вы можете получить значение :table из базы данных
      const table = "database";
      return redirect(`/game/coinFlip/${table}`);
    },
  },
  {
    path: "/game/coinFlip/:table/",
    element: (
      <Layout>
        <CoinFlipPage />
      </Layout>
    ),
  },
  {
    path: "/game/coinFlip/profile/create",
    element: (
      <Layout>
        <CoinFlipProfilePage />
      </Layout>
    ),
  },
  {
    path: "/game/coinFlip/profiles/create",
    loader: async () => {
      return redirect(`/game/coinFlip/profile/create`);
    },
  },
  {
    path: "/game/coinFlip/profile/",
    loader: async () => {
      return redirect(`/game/coinFlip/profiles/`);
    },
  },
  {
    path: "/game/coinFlip/profile/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/coinFlip/profile/${params.id}/${tab}`);
    },
  },
  {
    path: "/game/coinFlip/profiles/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/coinFlip/profile/${params.id}/${tab}`);
    },
  },
  {
    path: "/game/coinFlip/profile/:id/:tab",
    element: (
      <Layout>
        <CoinFlipProfilePage />
      </Layout>
    ),
  },
  {
    path: "/game/coinFlip/database/create",
    element: (
      <Layout>
        <CoinFlipEntityPage />
      </Layout>
    ),
  },
  {
    path: "/game/coinFlip/database/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/coinFlip/database/${params.id}/${tab}`);
    },
  },
  {
    path: "/game/coinFlip/database/:id/:tab/",
    element: (
      <Layout>
        <CoinFlipEntityPage />
      </Layout>
    ),
  },
];
